import { useMemo, useState, useEffect } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export function useMenuCameriereLogic({ menu }) {

  /* =========================
     STATE BASE
  ========================= */

  const [carrello, setCarrello] = useState([]);
  const [categoriaSelezionata, setCategoriaSelezionata] = useState(null);
  const [showRiepilogo, setShowRiepilogo] = useState(false);

  /* =========================
     AUTO-SET PRIMA CATEGORIA
  ========================= */

  useEffect(() => {
    if (!categoriaSelezionata && Array.isArray(menu) && menu.length > 0) {
      setCategoriaSelezionata(menu[0].categoria);
    }
  }, [menu, categoriaSelezionata]);

  /* =========================
     PIATTI FILTRATI
  ========================= */

  const piattiCategoria = useMemo(() => {
    if (!Array.isArray(menu)) return [];
    if (!categoriaSelezionata) return menu;
    return menu.filter(p => p.categoria === categoriaSelezionata);
  }, [menu, categoriaSelezionata]);

  /* =========================
     TOTALE CARRELLO
  ========================= */

  const totaleCarrello = useMemo(() => {
    return carrello.reduce((sum, item) => {
      const prezzo = parseFloat(item.prezzo) || 0;
      return sum + prezzo * item.quantita;
    }, 0);
  }, [carrello]);

  /* =========================
     CARRELLO
  ========================= */

  const aggiungiAlCarrello = (piatto) => {
      const custom = (piatto.custom || "").trim();
      setCarrello(prev => {
        const index = prev.findIndex(
          item =>
            item.id === piatto.id &&
            (item.custom || "") === (custom || "") &&
            item.stato === "inviato"
        );

        if (index !== -1) {
          // 🔥 aumenta quantità invece di duplicare
          const updated = [...prev];
          updated[index].quantita += 1;
          return updated;
        }

        // nuovo item
        return [
          ...prev,
          {
            id: piatto.id,
            nome: piatto.nome,
            prezzo: parseFloat(piatto.prezzo) || 0,
            categoria: piatto.categoria || null,
            custom: custom,
            quantita: 1,
            stato: "inviato",
            uid: Date.now().toString() + "_" + Math.random().toString(36).slice(2)
          }
        ];
      });

    setShowRiepilogo(true);
  };

  const modificaQuantita = (id, custom, nuovaQuantita) => {
    if (nuovaQuantita <= 0) {
      rimuoviDalCarrello(id, custom);
      return;
    }

    setCarrello(prev =>
      prev.map(i =>
        i.id === id && i.custom === custom
          ? { ...i, quantita: nuovaQuantita }
          : i
      )
    );
  };

  const rimuoviDalCarrello = (id, custom) => {
    setCarrello(prev =>
      prev.filter(i => !(i.id === id && i.custom === custom))
    );
  };

  /* =========================
     INVIO ORDINE
  ========================= */

  const inviaOrdine = async ({
    localeTag,
    tavolo,
    numeroCoperti,
    cameriere
  }) => {
    if (carrello.length === 0 || !tavolo) return false;

    const ordineData = {
      locale: localeTag,
      table: tavolo,
      piatti: carrello.map(item => ({
        nome: item.nome,
        prezzo: item.prezzo,
        quantita: item.quantita,
        categoria: item.categoria,
        custom: item.custom || ""
      })),
      items: carrello.map(item => ({
        name: item.nome,
        prezzo: item.prezzo,
        price: item.prezzo,
        quantita: item.quantita,
        quantity: item.quantita,
        categoria: item.categoria,
        custom: item.custom || ""
      })),
      totale: totaleCarrello,
      stato: "inviato",
      timestamp: serverTimestamp(),
      preso_da: "cameriere",
      cameriere_nome: cameriere || null,
      coperti: numeroCoperti || 1
    };

    await addDoc(collection(db, "ordini"), ordineData);

    setCarrello([]);
    setShowRiepilogo(false);

    return true;
  };

  /* =========================
     RETURN
  ========================= */

  return {
    categoriaSelezionata,
    piattiCategoria,
    carrello,
    totaleCarrello,
    showRiepilogo,
    setShowRiepilogo,
    setCategoriaSelezionata,
    aggiungiAlCarrello,
    modificaQuantita,
    rimuoviDalCarrello,
    inviaOrdine
  };
}
